import { Component, EventEmitter, Input, Output, output } from '@angular/core';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { AdHocInstructionDTO } from 'src/app/core/Dtos/ad-hoc/adhoc-instruction-dto';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-ad-hoc-viewer',
  templateUrl: './ad-hoc-viewer.component.html',
  styleUrl: './ad-hoc-viewer.component.scss',
  standalone: false
})
export class AdHocViewerComponent {
  @Input() public set InstructionId(instructionId: string | number) {
    if (instructionId !== 0)
      this.GetInstruction(instructionId);
    this._instructionId = instructionId;
  };

  public Instruction: AdHocInstructionDTO = new AdHocInstructionDTO();

  private _instructionId: string | number = '';

  constructor(
    private _adhocService: AdHocInstructionsService,
    private _alertService: AlertsService,
    public DateFormatHelper: DateFormatHelperService,
    public UserService: UserService,) {
  }



  GetInstruction(instructionId: string | number) {
    this._adhocService.GetInstructionById(instructionId).subscribe(
      resp => {
        this.Instruction = resp;
      }
    )
  }

  DownloadFile(fileId: number | string, fileName: string) {
    this._adhocService.DownloadFile(+fileId).subscribe(
      response => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';

        const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
        const contentDisposition = response.headers.get('Content-Disposition');

        let filename = 'default-file';
        if (fileName) {
          filename = fileName;
        }


        //create a blob from the response body
        const blob = new Blob([response.body], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        //set the download URL  and filename
        a.href = url;
        a.download = filename;
        a.click();

        //clean up url object
        window.URL.revokeObjectURL(url);
      },
      err => {
        this._alertService.ShowAlert(err);
      }
    )
  }
  ChangeStatus(status: string) {
    this._adhocService.ChangeStatus(this._instructionId, status).subscribe(
      resp => {
        this.GetInstruction(this._instructionId);
      }
    )
  }
}
